import { CollapsibleCard } from '@atgfr8/atg-ui-tailwind';
import { customerLTLSettings } from '@store/customers/customerDetails/LTL';
import { Accessor, Setter } from 'solid-js';
import { CarrierInfo } from '@typeDefinitions/carrierTypes';

import DefaultMargin from './DefaultMargin';
import MarginOverrides from './MarginOverrides';
import { InitialLTLFormValues } from '../Ltl';

const CostPlusMargins = (props: {
  setFields: (key: string, value: unknown) => void;
  data: Accessor<InitialLTLFormValues>;
  isValidCarrierChoice: (carrier: CarrierInfo) => boolean;
  setIsDirty: Setter<boolean>;
  onSectionChange: () => void;
}) => {
  return (
    <CollapsibleCard
      startTitle="Cost Plus Margins"
      loading={customerLTLSettings.isLoading}
      class="mb-2"
    >
      <DefaultMargin
        setFields={props.setFields}
        data={props.data}
        setIsDirty={props.setIsDirty}
        onSectionChange={props.onSectionChange}
      />
      <MarginOverrides
        setFields={props.setFields}
        data={props.data}
        isValidCarrierChoice={props.isValidCarrierChoice}
        setIsDirty={props.setIsDirty}
        onSectionChange={props.onSectionChange}
      />
    </CollapsibleCard>
  );
};

export default CostPlusMargins;
